import { useState } from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import { UpdateGraphModal } from "../UpdateGraphModal/UpdateGraphModal";

export default function UpdateChartsCard() {
  const [openSaveModal, setOpenSaveModal] = useState<boolean>(false)
  
  return (
    <>
      <UpdateGraphModal open={openSaveModal} onClose={() => setOpenSaveModal(false)} />
      <Card variant="outlined" sx={{ flexGrow: 1, mb: 2, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <CardContent>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <Typography component="h2" variant="subtitle1" fontWeight={600} gutterBottom>
              Update Data
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 1 }}>
              Click below to refresh all charts with the latest available data.
            </Typography>
            <Divider sx={{ width: "100%", mb: 1 }} />
            <Tooltip title="Fetch the latest data and update all charts">
              <Button
                variant="contained"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => setOpenSaveModal(true)}
                sx={{ minWidth: 160 }}
              >
                Update Charts
              </Button>
            </Tooltip>
          </Box>
        </CardContent>
      </Card>
    </>
  );
}